import React from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { Question } from "phosphor-react";
import { PropTypes } from "prop-types";

import { useI18n } from "../../../i18n/useI18n";

const [HbrButton, HbrDropdown, HbrMenu, HbrMenuItem, HbrIcon] =
    reactWrapper(["hbr-button", "hbr-dropdown", "hbr-menu", "hbr-menu-item", "hbr-icon", "hbr-link", "hbr-modal"]);

const HelpWidget = ({ openHelpModal, openHelpDrawer }) => {
    const { tGenerics } = useI18n('generics');

    const openNewAskPage = () => {
        const link = "https://cnb.cisco.com/web";
        window.open(link, '_blank');
    }

    const openNewGuidePage = () => {
        const link = "https://www.cisco.com/c/en/us/td/docs/routers/sdwan/config/ios-xe-sdwan17.html";
        window.open(link, '_blank');
    }

    const openModal = () => {
        openHelpModal(true);
    }
    const openDrawer = () => {
        openHelpDrawer(true);
    }

    return (
        <div>
            <HbrDropdown sentiment="header" distance="12">
                <HbrButton noPadding sentiment="header" slot="trigger">
                    <Question size={24} weight="bold" />
                </HbrButton>
                <HbrMenu>
                    <HbrMenuItem
                        value="help"
                        onClick={openDrawer}
                    >
                        {tGenerics('help')}
                    </HbrMenuItem>
                    <HbrMenuItem
                        value="helpGuide"
                        onClick={openNewGuidePage}
                    >
                        {tGenerics('helpUserGuide')}
                        <HbrIcon name="arrow-square-out" slot="suffix" width="22px" className="help-arrow-icon" />
                    </HbrMenuItem>
                    <HbrMenuItem value="helpAsk"
                        onClick={openNewAskPage}
                    >
                        {tGenerics('helpAsk')}
                        <HbrIcon name="arrow-square-out" slot="suffix" width="22px" className="help-arrow-icon" />
                    </HbrMenuItem>
                    <HbrMenuItem
                        value="helpAbout"
                        onClick={openModal}
                    >
                        {tGenerics('helpAbout')}
                    </HbrMenuItem>
                </HbrMenu>
            </HbrDropdown>
        </div>
    )
}

HelpWidget.propTypes = {
    openHelpModal: PropTypes.func,
    openHelpDrawer: PropTypes.func
}

export default HelpWidget;